import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/icomoon/style.css";
import "@/assets/styles/index.css";
import router from "./router";
import i18n from "@/plugins/i18n";
import definePlugins from "@/plugins";
import localizedRoutes from "@/plugins/localizedRoutes";
export const app = createApp(App);
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyApg0AczZqX7y9y8FU8rwGG_Xo6DEoAqVM",
  authDomain: "saraf-robot-4a6c7.firebaseapp.com",
  projectId: "saraf-robot-4a6c7",
  storageBucket: "saraf-robot-4a6c7.firebasestorage.app",
  messagingSenderId: "307760720559",
  appId: "1:307760720559:web:4072014c5558968b45425a",
  measurementId: "G-M83D3VXWP6",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);
app.use(router);
app.use(i18n);
app.use(localizedRoutes, { router });

definePlugins(app);

app.mount("#app");
